module.exports = __webpack_public_path__ + "media/images/common/sidenav_images-71b34bc0a4c36c5de50a6977ae1e6099.png";